import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { GlobalColorEnum } from '@/constants/global-color.enum'

interface SwitchProps {
  checked?: boolean
  defaultChecked?: boolean
  onChange?: (checked: boolean) => void
}

/**
 * antd를 대체하는 Switch 컴포넌트
 * */
export const Switch = ({ checked, defaultChecked = false, onChange }: SwitchProps) => {
  const [isChecked, setIsChecked] = useState(defaultChecked)

  const toggleSwitch = () => {
    const isNewChecked = !isChecked
    setIsChecked(isNewChecked)
    onChange?.(isNewChecked)
  }

  useEffect(() => {
    if (checked !== undefined) {
      setIsChecked(checked)
    }
  }, [checked])

  return (
    <StyledSwitchWrapper checked={isChecked} onClick={toggleSwitch}>
      <StyledSwitch checked={isChecked} />
    </StyledSwitchWrapper>
  )
}

const StyledSwitchWrapper = styled.div<{ checked: boolean }>`
  width: 4rem;
  height: 2rem;
  background-color: ${({ checked }) => (checked ? GlobalColorEnum.Blue400 : GlobalColorEnum.Gray200)};
  border-radius: 2.4rem;
  position: relative;
  cursor: pointer;
  transition: background-color 0.3s;
`

const StyledSwitch = styled.div<{ checked: boolean }>`
  width: 1.6rem;
  height: 1.6rem;
  background-color: white;
  border-radius: 50%;
  position: absolute;
  top: 0.2rem;
  left: ${({ checked }) => (checked ? '2.2rem' : '0.2rem')};
  box-shadow: 0 0.1rem 0.3rem rgba(0, 0, 0, 0.3);
  transition: left 0.3s;
`
